import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('farmsGrid');

    return {
        LAST_ACTIVITY: t('lastActivity'),
        LAST_EDITED: t('lastEdited'),
        LOADING: t('loading'),
        NAME: t('name'),
        NO_FARMS: t('noFarms'),
        NO_MORE_FARMS: t('noMoreFarms')
    };
};

export default useTranslation;
